import moment from 'moment'
class filters{
      constructor(  
            operId,
            from,
            to,
            mios,
            pending,
            approved,
            rejected,
            licenses,
            cSchedule,
            hsExtra,
            licF,
            dele,
            name,
            columnas
            ) {
    
      
      this.operId = operId
      this.from= moment(from).utc().format('DD-MM-YYYY')
      this.to = to == null ? ' ' : moment(to).utc().format('DD-MM-YYYY')
      this.mios = mios == true ? '✔️' : ''
      this.pending= pending == true ? '✔️' : ''
      this.approved = approved == true ? '✔️' : ''
      this.rejected= rejected == true ? '✔️' : ''
      this.licenses = licenses == true ? '✔️' : ''
      this.cSchedule= cSchedule == true ? '✔️' : ''
      this.hsExtra= hsExtra == true ? '✔️' : ''
      this.licF = licF == true ? '✔️' : ''
      this.dele= dele == true ? '✔️' : ''
      this.name = name
      this.columnas = columnas
      }
      static fromJson({ 
            operId,
            fecDesde,
            fecHasta,
            mios,
            pendientes,
            aprobadas,
            rechazadas,
            licencias,
            cHorario,
            hsExtra,
            licF,
            dele,
            Nombre,
            columnas
}) {
        return new filters(
            operId,
            fecDesde,
            fecHasta,
            mios,
            pendientes,
            aprobadas,
            rechazadas,
            licencias,
            cHorario,
            hsExtra,
            licF,
            dele,
            Nombre,
            columnas);
      }
    }
    export default filters